import { getValue } from '@utils/lodash';
import { NavLink } from 'react-router-dom';
import BackSvgComponent from '@assets/svg-components/back';
import { formatText } from '@common/text-helpers';
import { getColorStyle } from '@common/color';
import InfoSvgComponent from '@assets/svg-components/info';
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

function TripsStickyHeader(props: any) {
  const {
    route,
    handleSubmitTrip,
    submitTripLoading,
    handleRejectTrip,
    handleCompleteTrip,
    cancelBeforeBooking,
    cancelAfterBooking,
    handleSendBack,
  } = props;

  const getCurrentUser = () => {
    try {
      const storedUser = getValue(localStorage, `user`, '');
      return storedUser ? JSON.parse(storedUser) : {};
    } catch (error) {
      return {};
    }
  };
  const currentUser = getCurrentUser();
  const currentUserId = getValue(currentUser, `id`, '');
  const hasCurrentUserId = Boolean(currentUserId);

  const findCurrentApproverStausEnum = (arr: any) => {
    const currentApproverId = getValue(
      props,
      `formInfo.current_approver.id`,
      '',
    );
    const app =
      currentApproverId && getValue(arr, `length`, 0) > 0
        ? arr.filter(
            (item: object) =>
              String(getValue(item, `approver.id`, '')) ===
              String(currentApproverId),
          )
        : [];
    const awaitingApprover =
      getValue(arr, `length`, 0) > 0
        ? arr.find(
            (item: object) =>
              getValue(item, `approval_status`, '') === 'awaiting_approval',
          )
        : null;
    return getValue(app, `length`, 0) > 0
      ? getValue(app, `[${0}].approval_status`, '')
      : getValue(
          awaitingApprover,
          `approval_status`,
          getValue(
            props,
            `formInfo.current_approver.approval_status`,
            getValue(props, `formInfo.approval_status`, ''),
          ),
        );
  };
  const currentApproverStatus = findCurrentApproverStausEnum(
    getValue(props, `formInfo.trip_approvers`, ''),
  );
  const approvalStatus = getValue(props, `formInfo.approval_status`, '');
  const isAwaitingApproval =
    approvalStatus === 'awaiting_approval' ||
    currentApproverStatus === 'awaiting_approval';
  const displayApprovalStatus =
    approvalStatus === 'unsubmitted' && isAwaitingApproval
      ? 'awaiting_approval'
      : approvalStatus || currentApproverStatus;
  const isSentBackHistoryByCurrentUser = getValue(props, `histoyList`, []).some(
    (item: any) =>
      String(getValue(item, `description`, '')).toLowerCase().includes(
        'sent back',
      ) &&
      hasCurrentUserId &&
      String(
        getValue(
          item,
          `approver.id`,
          getValue(item, `approver`, getValue(item, `created_by.id`, '')),
        ),
      ) === String(currentUserId),
  );
  const isSentBackCommentByCurrentUser =
    hasCurrentUserId &&
    String(getValue(props, `sentBackComment.created_by.id`, '')) ===
    String(currentUserId);
  const showUndoSentBackButton =
    getValue(props, `admin`, false) &&
    approvalStatus === 'sent_back' &&
    (isSentBackCommentByCurrentUser || isSentBackHistoryByCurrentUser);
  const showApprovalButtons =
    getValue(props, `admin`, false) && isAwaitingApproval;
  const showSendBackButton =
    getValue(props, `admin`, false) &&
    ['approved', 'awaiting_approval'].includes(displayApprovalStatus);

  return (
    <div className="common-sticky-header">
      <section className="inner-page-navigation-with-back-cta-buttons position-relative">
        <div className="container-fluid  d-flex justify-content-between align-items-center">
          <div>
            <div className="d-flex justify-content-between align-items-center">
              <NavLink to={route ? `${route}` : '#'}>
                <BackSvgComponent />
              </NavLink>
              <p className="header_text">
                {getValue(props, `formInfo.trip_id`, 'Trips')}
              </p>
              <h6
                className="header_text__16 ms-3"
                style={getColorStyle(displayApprovalStatus)}
              >
                {formatText(displayApprovalStatus)}
              </h6>
            </div>
          </div>
          {getValue(props, `permissions`, []).includes('update') && (
            <div className="d-flex align-items-center">
              {showApprovalButtons && (
                <>
                  <button
                    className={`ascent-button ascent-button--header-buttons ascent-button--green`}
                    onClick={() => handleSubmitTrip('approve')}
                    disabled={submitTripLoading}
                    style={{ fontWeight: '400' }}
                  >
                    Approve
                  </button>
                  <button
                    className={`ascent-button ascent-button--header-buttons ascent-button--red`}
                    onClick={() => handleRejectTrip('reject')}
                    disabled={submitTripLoading}
                    style={{ fontWeight: '400' }}
                  >
                    Reject
                  </button>
                </>
              )}
              {showSendBackButton && (
                <button
                  className={`${showApprovalButtons ? 'ms-2 ' : ''}ascent-button ascent-button--header-buttons ascent-button--orange`}
                  onClick={() => handleSendBack('sent-back')}
                  disabled={submitTripLoading}
                  style={{ fontWeight: '400' }}
                >
                  Send Back to User
                </button>
              )}
              {showUndoSentBackButton && (
                <button
                  className="ms-2 ascent-button ascent-button--header-buttons ascent-button--secondary"
                  onClick={() => handleSendBack('undo-sent-back')}
                  disabled={submitTripLoading}
                  style={{ fontWeight: '400' }}
                >
                  Undo Send Back
                </button>
              )}
              {!showApprovalButtons &&
                !showSendBackButton &&
                !showUndoSentBackButton && (
                  <div style={{ height: '48px' }}></div>
                )}
            </div>
          )}
          <div className="d-flex align-items-center">
            {getValue(props, `histoyList.length`, 0) > 0 && (
              <div
                className="mx-2 border p-2 border-radius__5 d-flex align-items-center"
                onClick={props.toggleHistory}
              >
                <InfoSvgComponent color={'gray'} />
                <h6 className="header_text__16 cursor-pointer ms-1">History</h6>
              </div>
            )}
            {getValue(props, `admin`, false) && (
              <button
                className={`ascent-button ascent-button--header-buttons ascent-button--secondary`}
                onClick={() => props.handleForexPopup()}
                style={{ fontWeight: '400' }}
              >
                Request Forex
              </button>
            )}

            {getValue(props, `admin`, false) &&
              getValue(props, `formInfo.approval_status`, '') === 'approved' &&
              getValue(props, `permissions`, []).includes('update') && (
                <>
                  {/* <button
                    className={`ascent-button ascent-button--header-buttons ascent-button--green`}
                    onClick={() => handleCompleteTrip()}
                    disabled={submitTripLoading}
                    style={{ fontWeight: "400" }}
                  >
                    {submitTripLoading ? "Please wait..." : "Complete"}
                  </button> */}

                  <UncontrolledDropdown
                    className="trip-update-status-wrap"
                    direction="end"
                    container={'body'}
                  >
                    <DropdownToggle>
                      <button
                        className={`ascent-button ascent-button--header-buttons ascent-button--primary ms-1`}
                      >
                        Update Status
                      </button>
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem onClick={() => handleCompleteTrip()}>
                        <div className={`more-dropdown-main-item `}>
                          <p>Mark as Complete</p>
                        </div>
                      </DropdownItem>
                      <DropdownItem onClick={() => cancelBeforeBooking()}>
                        <div className={`more-dropdown-main-item `}>
                          <p>Cancelled before booking</p>
                        </div>
                      </DropdownItem>
                      <DropdownItem onClick={() => cancelAfterBooking()}>
                        <div className={`more-dropdown-main-item `}>
                          <p>Cancelled after booking</p>
                        </div>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </>
              )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default TripsStickyHeader;
